require("../../libs/backbone/backbone.ajaxq.adapter.ts");
var GenericView = require('views/generic.view.ts');
var Handlebars = require('handlebars');
var Template = require('text-loader!../templates/kiosk.template.htm');
require('dhtmlxMessage');
var Model = require('../models/kiosks.model.ts');
var QueuesOptions = require("views/kiosks_queues_options.view.ts");
var i18n = require('l10n');

var TheView = GenericView.extend({
    el: "#container",
    tagName: 'div',
	template: Handlebars.compile(Template),
	superInitialize: GenericView.prototype.initialize,
	model : null,
	id: null,
    editable: null,
    fields: null,
    userData: null,
    privilegeLevel: null,
    back: false,
	initialize: function (options) {
	    var self = this;
	    this.id = options ? options.id : null;
        this.userData = options.data;
        this.privilegeLevel = this.privilegeLevelToNumber(this.userData.privilegeLevel);

        if(this.id) {
            this.editable = true;
            this.model = new Model({ id : this.id });
            this.model.fetch({
                success: function(response)
                {
                    self.render();
                },
                error: function(response, xhr, status)
                {

                }
            });
        } else {
            this.editable = false;
            this.model = new Model();
            this.render();
        }

        this.fields =
        {
            name: [this.isEmpty]
        }
	},
	superRender: GenericView.prototype.render,
	render: function () {  
        this.superRender();
		var self = this;

		var data = $.extend(this.model.toJSON(), { editable: this.editable, queueType: 'queuesCounters' });

        this.$el.html(this.template(data));

        this.queuesOptions = new QueuesOptions(data);

	},
	events: {
        "click #submitBack": "clickOnSubmitBack",
        "click #reset": "clickOnReset",
        "click #cancel": "onCancel",
        "change .to-validation input": "validateIt",
        "keyup .to-validation input": "validateIt",
        "focusout .to-validation input": "validateIt",
	},
    onCancel: function()
    {
       this.goBack();
    },
	clickOnReset: function(e)
    {
        $("#name").find("input").val("");
    },
	clickOnSubmitBack: function(e)
    {
       this.back = true;
        this.clickOnSubmit(null);

    },
	clickOnSubmit: function(e)
    {
        var self = this;

        var fields = {
            name: [this.isEmpty]
        };

        var has_error = this.validateFields(fields);

        if(!has_error)
        {
            this.model.set("name", $("#name").find("input").val().trim());
            var selectedQueues = this.getSelectedQueues() !== undefined ? this.getSelectedQueues() : [];
            this.model.set("queues", selectedQueues);
            this.showActionProgressBar();

            this.model.save(null, {
                success: function(response) {
                    //Hide the generic progress bar
                    self.hideActionProgressBar();
                    if(self.editable)
                    {
                        $.notify(i18n.t("kiosks.kiosk_updated"), { position:"top center", className: "success" });

                        if(self.back)
                            self.goBack();
                        self.back = false;
                    }
                    else
                    {
                        $.notify(i18n.t("kiosks.kiosk_added"), { position:"top center", className: "success" });
                        self.goBack();
                    }
                },
                error: function(model, response) {
                    var responseJSON = response.responseJSON || {};
                    var errorList = responseJSON.error || [];
                    
                    if (response.status == 409) {
                        if (responseJSON.error === "Kiosk name already exists") {
                            self.hideActionProgressBar();
                            $.notify(i18n.t("kiosks.err_kiosk_name_already_exists"), { position: "top center", className: "error" });
                        }
                    }

                    if (Array.isArray(errorList) && errorList.length > 0) {
                        var errorCode = errorList[0].code;

                        self.hideActionProgressBar();
                        if (errorCode == 120) {
                            $.notify(i18n.t("kiosks.err_empty_queues"), { position: "top center", className: "error" });
                        } else if (errorCode == 121) {
                            $.notify(i18n.t("kiosks.err_up_to_four_queues"), { position: "top center", className: "error" });
                        }
                    }
                }
            });
        }
        else {
            this.hideActionProgressBar();
            $.notify(
                i18n.t("account.check_errors"),
                { position:"top center", className: "error" }
            );
        }

    },
    validateIt: function(event)
    {
        if(event.which > 36 && event.which < 41)
            return;

        var element = $(event.currentTarget).parent();
        var field = {};
        field[element.prop("id")] = this.fields[element.prop("id")]

        var has_error = this.validateFields( field );
    },
    getSelectedQueues: function() {
        var queuesIdsArray = [];
        var queuesName = [];

        this.$el.find('#kQueuesOptions .chosen-choices .search-choice').each(function() {
            var option = $(this).find('span').text();
            var match = option.match(/^\d+(?= -)/);

            if (match) {
                var queueId = parseInt(match[0], 10);
                queuesIdsArray.push(queueId);
            }
        });

        return queuesIdsArray;
    }
});

module.exports = TheView;